import { makeStyles } from '@material-ui/core';

export const useStyles = makeStyles({
  mTop: {
    marginTop: 32,
  },
});
